<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div class="headline">Occupancy Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.occupancy }}</td>
          <td class="text-xs-left">{{ props.item.occupancyDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview(props.item.occupancy)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" dark class="mb-2" @click="doNew">
      New Occupancy
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="occupancyDialog" width="800px" lazy persistent v-if="checkAccess(['fireRatingReview'])">
      <v-card>
        <v-card-title>
          <span class="headline">Occupancy</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newOccupancy">
                <v-text-field :label="labels.occupancy" v-model="occupancyForm.occupancy" :error-messages="errors.collect('occupancy')" data-vv-name="occupancy" :data-vv-as="labels.occupancy" v-validate="'required|param|max:2'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.occupancy}}</v-subheader>
                <div class="title">{{occupancyForm.occupancy}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.occupancyDesc" v-model="occupancyForm.occupancyDesc" :error-messages="errors.collect('occupancyDesc')" data-vv-name="occupancyDesc" :data-vv-as="labels.occupancyDesc" v-validate="'required|entry|max:40'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Occupancy', value: 'occupancy' },
        { text: 'Description', value: 'occupancyDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        occupancy: 'Occupancy*',
        occupancyDesc: 'Description*'
      },
      newOccupancy: false,
      occupancyDialog: false,
      occupancyForm: {
        occupancy: null,
        occupancyDesc: null
      },
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiUrl = this.fireMenu.getAllFireOccupancy
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (result.data) {
            this.items = []
            data.map(fireOccupancy => {
              const convertList = {
                occupancy: fireOccupancy.occupancy,
                occupancyDesc: fireOccupancy.occupancyDesc
              }
              this.items.push(convertList)
            })
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.fullMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
      this.loading = false
    },
    doNew() {
      this.occupancyDialog = this.newOccupancy = true
      this.occupancyForm.occupancy = this.occupancyForm.occupancyDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    async doReview(occupancy) {
      const apiURI = this.fireMenu.getFireOccupancy
      if (apiURI) {
        const expand = {
          occupancy
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.occupancyForm.occupancy = data.occupancy.occupancy
          this.occupancyForm.occupancyDesc = data.occupancy.occupancyDesc
          this.occupancyDialog = true
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newOccupancy) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.fireMenu.createFireOccupancy
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.occupancyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.fireMenu.updateFireOccupancy
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.occupancyForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(occupancy) {
      this.resetMessages()
      this.selectedId.id = occupancy.occupancy
      this.selectedId.text = occupancy.occupancy + ' - ' + occupancy.occupancyDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.fireMenu.deleteFireOccupancy
      if (apiURI) {
        const expand = {
          occupancy: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.doFetch()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    doClose() {
      this.occupancyDialog = this.newOccupancy = false
      this.occupancyForm.occupancy = this.occupancyForm.occupancyDesc = null
      this.resetValidator()
      this.resetMessages()
    }
  },
  created() {
    this.doFetch()
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    fireMenu() {
      return this.$store.state.fire.menu
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
